export const MILLISECOND = 1000;
export const SIXTY = 60;
export const TIMEOFDAY = 24;
